<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>location_on</md-icon>
      </div>
      <h4 class="title">
        Itinerary
      </h4>
      <md-button
        class="md-dense md-primary"
        @click="addAllDays()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Create all Dates
      </md-button>
      <md-button
        class="md-dense md-primary"
        @click="addDay()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Add an Item
      </md-button>
    </md-card-header>
    <md-card-content>
      <md-table v-model="sortedItinerary" md-card>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Date">
            <md-datepicker
              v-model="item.date"
              md-immediately
              :md-model-type="String"
            >
            </md-datepicker>
          </md-table-cell>
          <md-table-cell md-label="Day">
            <md-field>
              <md-input
                readonly
                :value="item.date | getDayFromDate"
                type="text"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Start Location">
            <md-field>
              <md-input v-model="item.start_location" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Ride">
            <md-field>
              <md-input v-model="item.ride" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="End Location">
            <md-field>
              <md-input v-model="item.end_location" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell>
            <md-button
              class="md-danger md-just-icon md-simple"
              @click.stop="removeItem(item)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">Remove Entry</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`We can't find any details to show.`"
        >
        </md-table-empty-state>
      </md-table>
      <md-button
        class="md-dense md-primary"
        @click="save"
        :disabled="saving"
        style="margin-top: 1rem"
      >
        <md-icon>save</md-icon>
        Save
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";
import moment from "moment";
import { getMissingDepartureDates } from "@/helpers/reservations";

export default {
  props: {
    manifest: {
      itinerary: [],
      dinners: [],
      reservations: []
    },
    departure: {}
  },

  data() {
    return { saving: false };
  },

  computed: {
    sortedItinerary() {
      return this.manifest.itinerary
        .slice()
        .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
    }
  },

  methods: {
    addAllDays() {
      const existingDates = (this.manifest.itinerary || []).map(
        itinerary => itinerary.date
      );
      getMissingDepartureDates(
        this.departure.start_date,
        this.departure.end_date,
        existingDates
      ).forEach(this.addDay);
    },

    addDay(date = null) {
      this.manifest.itinerary.push({
        date: date ? moment().format(date) : moment().format("YYYY-MM-DD"),
        start_location: "",
        ride: "",
        end_location: ""
      });
    },

    removeItem: function(item) {
      this.manifest.itinerary.splice(this.manifest.itinerary.indexOf(item), 1);
    },

    save() {
      if (this.saving) return;
      this.saving = true;
      return departureApi
        .saveManifestSection(
          this.departure.id,
          "itinerary",
          this.manifest.itinerary
        )
        .then(response => {
          this.$set(this.manifest, "itinerary", response.data.rows);
          this.$notify({
            timeout: 2500,
            message: "Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {
          const message = error.response?.data?.message;
          this.$notify({
            timeout: 5000,
            message:
              typeof message === "object" && message
                ? Object.values(message)
                    .flat()
                    .join(" ")
                : message || "Unable to save. Please try again.",
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
<style lang="scss"></style>
